import React from 'react';
import CoaForm from '../contracts/CoaForm';
import { useEditCoaModalQuery } from '../../graphql';

export interface ShipmentCoaProps {
  coaId: number;
}

const ShipmentCoa = ({ coaId }: ShipmentCoaProps): JSX.Element | null => {
  const { data } = useEditCoaModalQuery({ variables: { coaId } });
  const coa = data?.coaContractById ?? undefined;

  return data ? <CoaForm coa={coa} isReadonly /> : null;
};

export default ShipmentCoa;
